<template>
  <ion-toolbar>
   <ion-title>
   
       <span v-if="job.convertedDate">{{ job.convertedDate }}</span>
       <span v-else>Guest Shift</span>
   </ion-title>
  </ion-toolbar>


 <div class="main_wrapper ion-padding">
  <div class="container">
      <div class="job_info_wrapper job_info_wrapper--custom">
      <div
        class="image_text_comp image_text_comp--mb"
        v-if="job.pharmacy"
      >
        <div class="image_wrapper">
          <el-avatar
            :size="'small'"
            shape="square"
            :src="job.pharmacy.image"
            v-if="job.pharmacy.image"
          />
          <el-avatar
            :size="'small'"
            shape="square"
            icon="el-icon-user-solid"
            v-else
          ></el-avatar>
        </div>
        <div class="text_wrapper">
          <div class="main_text">{{ job.pharmacy.name }}</div>
          <div class="additional_text">
            <span>{{ $filters.addressText(job.pharmacy.address) }}</span>
          </div>
        </div>
      </div>
      <div class="rate_shifts_info">
          <div class="info_wrapper">
            <div class="info_title info_title--big">Shift dates</div>
            <div class="info_value">
              <span>{{ job.convertedDate }}</span>
            </div>
          </div>
        </div>

        <el-table :data="job.shiftDatas" style="width: 100%">
      <el-table-column prop="date" label="Date" width="180" />
      <el-table-column prop="startTime" label="Start time" width="180" />
      <el-table-column prop="endTime" label="End Time" />
    </el-table>

        <div class="info-outer">
          <div class="info_wrapper" v-if="job.notes">
            <div class="info_title info_title--big">Shift Notes</div>
            <div class="info_value  info_value-job">
              <span style="white-space: pre-line">{{ job.notes }}</span>
            </div>
          </div>
          <div v-else></div>
        </div>
        
        <el-form
          class="job_shifts_wrapper fullp"
          :model="formsData.userForm"
          :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)"
          :label-position="'top'"
          @submit.prevent="submit('userForm')"
      >
          <el-form-item :required="false" class="el-form-item-check">
            <el-checkbox v-model="formsData.userForm.acceptLocumateTc.value" disabled 
              > I Accept the Locumate
            </el-checkbox>
            <span class="tc-link"><router-link :to="{ name: 'terms_and_conditions_guest_shift' }"> T&C's</router-link></span>
          </el-form-item>
          <el-form-item :required="false">
            <el-checkbox v-model="formsData.userForm.acceptPharmacyTc.value" disabled 
              > I Accept the Pharmacy 
            </el-checkbox>
            <span class="tc-link"  @click="showPopup()"> T&C's</span>
          </el-form-item>
          <div
              class="preview_square preview_square--block  preview_square--custom"
              v-if="aphraRegistration.length"
            >
              <div class="proof-ins"> <strong> Aphra Document</strong></div>
                <div class="el-upload-list">
                  <div class="el-upload-list__item" v-for="(file) in aphraRegistration" :key="file.url">
                    <div class="thumbnail_img el-upload-list--picture-card">
                      <div v-if="file.extension == 'pdf'"> 
                        <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                      </div>
                      <div v-else>
                        <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url"
                        alt=""
                      />
                      </div>
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="certPreviewModalOpen(file)"
                        >
                          <i class="el-icon-zoom-in"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
              class="preview_square preview_square--block  preview_square--custom"
              v-if="insuranceDocument.length"
            >
              <div class="proof-ins"> <strong>Insurance Document</strong> </div>
                <div class="el-upload-list">
                  <div class="el-upload-list__item" v-for="(file) in insuranceDocument" :key="file.url">
                    <div class="thumbnail_img el-upload-list--picture-card">
                      <div v-if="file.extension == 'pdf'"> 
                        <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                      </div>
                      <div v-else>
                        <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url"
                        alt=""
                      />
                      </div>
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="certPreviewModalOpen(file)"
                        >
                          <i class="el-icon-zoom-in"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
          <el-form-item >
            <div>
            <div class="demo-collapse ">
              <el-collapse accordion>
                <el-collapse-item :title="`What is ${$filters.appName()}`" name="1">
                  <div class="search_jobs_header">
                    <img
                      :src="require(`@/assets/img/illustrations/search1.svg`)"
                      alt=""
                    />
                    <div class="main_title">What is {{$filters.appName() }}</div>
                    <div class="mt-2 fz" v-if="isAustralia">
                        Australia’s Locum Marketplace. We help pharmacies engage with the largest network of trusted
                        independent
                        locums to cover illnesses, holidays and training… or just to help out when it’s super busy.
                      </div>
                      <div v-else>
                        We empower pharmacy professionals to take control of their careers, with the flexibility to choose when and where they work while for pharmacies we create capacity, alleviate staff shortages, and address burnout, ultimately enhancing patient care.
                      </div>
                    <!-- <el-button class="mt-3" :type="'blue'" @click="links.createJob"> -->
                    <el-button class="mt-3" :type="'blue'" @click="close()">
                      Sign up to {{$filters.appName() }}
                    </el-button>

                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            </div>
          </el-form-item>
        <el-form-item   class="button_submit mb0">

          <el-button
              class="submit_page"
              type="red"
              @click="close()"

          >
            Close
          </el-button>
        </el-form-item>
      </el-form>
      
    </div>
  </div>
 </div>

 <el-dialog v-model="centerDialogVisible" title="Pharmacy T&C's" width="30%" center >
  
   <div v-if="job.guest.termsAndConditions">
     <p style="white-space: pre-line">{{ job.guest.termsAndConditions }}</p>
     <!-- {{{ job.guest.termsAndConditions }}} -->
   </div>

   <div  v-if="job.contractUrl">
     <div class="image_wrapper">
           <div class="download-img-wrap">
             <div class="download-img">
               <a :href="job.contractUrl" target="_blank" download>  
                 <!-- <span class="locumate_icons locumate_icon-picture"></span> -->
                 <p class="download-btn">Download Contract <i class="el-icon-download"></i></p>
               </a>
             </div>
            
           </div>
         </div>
   </div>
 </el-dialog>

 <cert-preview-modal
    :modalName="'certPreviewModal'"
    :options="certPreviewModal"
  />
</template>

<script>


import {
 ref,
 onMounted,
 inject,
 // computed,
} from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
addIcons({
 "arrow-back-outline": arrowBackOutline,
});

import { useStore } from "vuex";
import {
 useRouter,
 // useRoute
} from "vue-router";
import { CertPreviewModal } from "@/modals/modals";

export default {
  components: {
    "cert-preview-modal": CertPreviewModal,
  },
 setup() {
   const $store = useStore();
   const $router = useRouter();
  
   const setPageClassGlobal = inject("setPageClassGlobal");
   const centerDialogVisible  = ref(false);
   let disabled = ref(true);
   let job = ref($store.getters.getGuestShiftPublicDetails);
   console.log("guest shift are",job);
   let guest = ref(job.value.guest);
   let pharmacy = ref(job.value.pharmacy);
  console.log("pharmacy", pharmacy);

  const aphraRegistration = ref(job.value.aphraUrls);
  const insuranceDocument = ref(job.value.insuranceUrls);
  const isAustralia = isAustraliaRegion();
   const $modals = inject("$modals");
    const certPreviewModal = ref({
      name: "certPrev",
      file: [],
    });
    const certPreviewModalOpen = (file) => {
      console.log("hehehhe",file)
      if(file.extension == 'pdf'){
        window.open(file.url, '_blank');
      }else{
        certPreviewModal.value.file = file;
      $modals.open("certPreviewModal", {
        file: file,
      });
    }
    };


   const formsDataArray = {
     userForm: {
       acceptLocumateTc: {
         value: true,
       },
       acceptPharmacyTc: {
         value: true,
       },
       aphraRegistration: {
         ref: null,
         value: [],
         limit: 10,
         disabled: false,
         validators: [
             {
             validator: (rule, formField, callback) => {
                 formValidate.validate(
                 rule,
                 formField,
                 "gallery",
                 callback,
                 setFormValidation
                 );
             },
             },
         ],
         errors: null,
         },
     insuranceDocument: {
     ref: null,
     value: [],
     limit: 10,
     disabled: false,
     validators: [
         {
         validator: (rule, formField, callback) => {
             formValidate.validate(
             rule,
             formField,
             "gallery",
             callback,
             setFormValidation
             );
         },
         },
     ],
     errors: null,
     },
     },
   };

   const showPopup = () =>{
      centerDialogVisible.value = true;
   
   }

   const close=()=>{
      $router.push({
          name: "auth",
        });
    }
  

   onMounted(() => {
     setPageClassGlobal("global_job_book_page");
     
   });


   const {
     setFormValidation,
     formsData,
   } = formHooks(formsDataArray);
   return {
     formsData,
     job,
     guest,
     disabled,
     pharmacy,
     centerDialogVisible,
     showPopup,
     aphraRegistration,
     insuranceDocument,
     certPreviewModalOpen,
     certPreviewModal,
     close,
     isAustralia
   };
 },
};
</script>
